import React, { useEffect, useState } from 'react';
import '../App.css';

import HeroSlider from '../components/HeroSlider';
import FeaturedCategories from '../components/FeaturedCategories';
import PipeSystemSection from '../components/PipeSystemSection';
import SloganSection from '../components/SloganSection';
import BrandsGrid from '../components/BrandsGrid';
import CustomerSlider from '../components/CustomerSlider';
import AboutCompany from '../components/AboutCompany';
import PurchaseProcess from '../components/PurchaseProcess';
import MainCategoryGrid from '../components/MainCategoryGrid';

import { api } from '../services/api';

export default function HomePage() {
  const [categories, setCategories] = useState([]);
  const [loadingCats, setLoadingCats] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoadingCats(true);
    api
      .getCategories()
      .then((res) => mounted && setCategories(res?.data || []))
      .catch(() => mounted && setCategories([]))
      .finally(() => mounted && setLoadingCats(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main className="App" dir="rtl">
      <HeroSlider />
      <FeaturedCategories />
      <PipeSystemSection />
      <SloganSection />
      <MainCategoryGrid
        categories={categories}
        subtitle={loadingCats ? 'در حال دریافت دسته‌بندی‌ها از داشبورد...' : `انتخاب از ${categories.length} دسته اصلی`}
      />
      <BrandsGrid />
      <CustomerSlider />
      <AboutCompany />
      <PurchaseProcess />
    </main>
  );
}
